import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab1 = ({ customertypelist, setCustoemrtype, customertype, setCustoemrName,
    customername, setMobile, mobile,
    customergrplist, setcustomerGrp, customergrp,
    terilist, terittory, setTerittory,
    setlead, lead, leadlist,
    setAccount, account, accountlist,
       isGroup,setIsGroup,
    setCurrency,currency,currencylist,
    price,setPrice,pricelist,
    setBankAccount,bankAccount,banklist,
     setMarket, market, marketList,
    industry,setIndustry,industrylist,
    website,setWebsite,
    customerDetails,setCustomerDetails
}) => {
    return (

        <div>
            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >



                <div className="col-12">
                    <p className="boxLabel m-0">Details</p>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="CustomerName"
                                label="Customer Name"
                                style={{ height: "30px" }}
                                readOnly
                                value={customername}
                                onChange={(e) => setCustoemrName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={customertypelist || []}
                                label="Customer Type"
                                value={customertype}
                                onChange={(val) => setCustoemrtype(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Mobile"
                                label="Mobile"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={customergrplist}
                                label="Customer Group"
                                value={customergrp}
                                onChange={(val) => setcustomerGrp(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=" "
                            />
                        </div>
                    </div>
                </div>
                <div className="col-4 ">
                    <div className="mb-3">
                        <SelectSearch
                            list={terilist}
                            label="Territory"
                            value={terittory}
                            onChange={(val) => setTerittory(val)}
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder=" "
                        />
                    </div>
                </div>
                <div className="col-4">
                    <div className="mb-3">
                        <SelectSearch
                            list={leadlist}
                            label="From Lead"
                            value={lead}
                            onChange={(val) => setlead(val)}
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder=" "
                        />
                    </div>
                </div>
                <div className="col-4">
                    <div className="mb-3">
                        <SelectSearch
                            list={accountlist}
                            label="Account Manager"
                            value={account}
                            onChange={(val) => setAccount(val)}
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder=" "
                        />
                    </div>
                </div>
            </div>
            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Defaults</p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={currencylist || []}
                                label="Billing Currency"
                                value={currency}
                                onChange={(val) => setCurrency(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={banklist || []}
                                label="Default Company Bank Account"
                                value={bankAccount}
                                onChange={(val) => setBankAccount(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={pricelist || []}
                                label="Default Price List"
                                value={price}
                                onChange={(val) => setPrice(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                </div>

                <div className=' mb-3 mx-3' style={{ display: 'flex', gap: '1rem', gap: '130px' }}>
                    <div>
                        <input
                            type="checkbox"
                            id="defaultCheck"
                            className="form-check-input mt-2" style={{ width: '12px', height: '12px' }}
                            checked={isGroup === 1}
                            onChange={(e) => setIsGroup(e.target.checked ? 1 : 0)}
                        />
                        <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem', fontSize: '10px', color: '#00000099' }}>Is Internal Customer</label>
                    </div>
                </div>


            </div>
            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">More Information </p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={industrylist || []}
                                label="Industry Type"
                                value={industry}
                                onChange={(val) => setIndustry(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={marketList || []}
                                label="Market Segment"
                                value={market}
                                onChange={(val) => setMarket(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="CustomerName"
                                label="Website"
                                style={{ height: "30px" }}
                                value={website}
                                onChange={(e) => setWebsite(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='mt-2 mb-3' style={{ display: 'flex', gap: '1rem', gap: '130px' }}>
                    <div>

                        <Textarea
                            label={"Customer Details"}
                            style={{ width: '655px' }}
                            value={customerDetails}
                            onChange={(e) => setCustomerDetails(e.target.value)}

                        />
                    </div>
                </div>
                <div className='mx-2' style={{ fontSize: '10px', color: '#00000099' }}>
                    <p>Additional information regarding the customer.</p>
                </div>

            </div>
                 <div className="">
                <ActivityCard doctype="Customer" docname={customername} />
            </div>




        </div>
    )
}

export default Tab1